export default {
  verboseName: "Persona",
  verboseNamePlural: "Persone",
  modelName: "Person",
  modelNamePlural: "People",
  appName: "people",
  propName: "person",
  propNamePlural: "people",
}
